import React, { useContext, useState } from 'react'
import './footer.scss'
import {PROVIDER_NAME, PARENT_PROVIDER_NAME} from '../../config';
import { Button, Modal } from 'react-bootstrap';
import Eula from '../Eula';
import { DataContext } from '../../js/App';


const Footer = () => {    
const year = new Date().getFullYear() ;
const [showEula, setShowEula] = useState(false);
const context = useContext(DataContext);
const { privacyPolicy } = context;

    return (<>
        <Modal show={showEula} onHide={() => setShowEula(false)} dialogClassName="modal-90w">
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    Privacy policy
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Eula />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => setShowEula(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
        <div className="footer-container">
            <div className='footer'>
                <div className="footer-text">
                    <div className="copyright">Copyright &copy; {year} {PARENT_PROVIDER_NAME !== "" ? PARENT_PROVIDER_NAME : PROVIDER_NAME}</div>
                    {privacyPolicy === null ? (
                        <div className="links" onClick={() => setShowEula(true)}>Privacy Policy</div>
                    ) : (<div className="links"><a target={"_blank"} href={privacyPolicy}>Privacy Policy</a></div>)}
                </div>     
            </div>       
        </div>
        </>
    )
}

export default Footer;
